import { XIcon } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Button } from 'src/domains/common/components/button/button';

interface BannerPropsType {
    title: string;
    settings: string | undefined;
    sports: string;
    onClose: () => void;
}

export const Banner = observer(({ title, settings, sports, onClose }: BannerPropsType) => {
    return (
        <div className='flex h-auto w-full px-2 justify-between bg-[hsl(var(--primary)_/_0.1)] rounded-t-md items-center text-xs sticky top-0 z-10'>
            <div className='flex flex-row gap-x-4 gap-y-1 flex-wrap truncate'>
                <div className='flex flex-row gap-2 truncate'>
                    <span className='text-muted-foreground'>Title:</span>
                    <span className='truncate'>{title}</span>
                </div>
                {typeof settings === 'string' && (
                    <div className='flex flex-row gap-2 truncate'>
                        <span className='text-muted-foreground'>Settings:</span>
                        <span className='truncate'>{settings}</span>
                    </div>
                )}
                <div className='flex flex-row gap-2 truncate'>
                    <span className='text-muted-foreground'>Sports:</span>
                    <span className='truncate'>{sports}</span>
                </div>
            </div>
            <Button
                variant='ghost'
                onClick={onClose}
                className='w-8 h-8 p-2'
            >
                <XIcon
                    height={16}
                    width={16}
                />
            </Button>
        </div>
    );
});
